<template>
    <div v-if="isLocked" class="lock-screen">
        <div class="lock-box">
           
            <div>
                <p>Bonjour <b>{{ user?.firstName || '' }} {{ user?.lastName || '' }}</b>, </p>
                <p>Votre session Gymya a été verrouillée pour des raisons de sécurité.</p>
                <p>
                    Veuillez entrer votre code PIN pour déverrouiller votre session et continuer à utiliser
                    l’application.
                </p>
                <br>
            </div>
            <div class="warning">
                <p>
                    ⚠️ Le code PIN par défaut est <b>1230</b>.
                    Veuillez le modifier pour plus de sécurité et le mémoriser.
                </p>
            </div>
            <div class=" ">
                <input v-model="pin" type="password" placeholder="Enter PIN" @keyup.enter="unlock" class="form-control">
            </div>
            <div>
                <button @click="unlock" class="btn btn-search mr-2">
                    <font-awesome-icon icon="fa-lock-open" size="lg" class="link-icon" />
                    Unlock
                </button>
            </div>
            
            <div  v-if="error" >
                <br>
                <p class="error">
                    Veuillez vérifier votre code et réessayer.
                </p>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAppLock } from '@/composables/lock/useAppLock'
import { user } from '@/shared/state';

const pin = ref<string>('')
const error = ref<boolean>(false)

const {
    isLocked,
    checkPin,
    unlockApp
} = useAppLock()

const unlock = () => {
    if (checkPin(pin.value)) {
        unlockApp()
        pin.value = ''
        error.value = false
    } else {
        error.value = true
    }
}
</script>

<style scoped>
.lock-screen {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
}

.lock-box {
    width: 720px;
    background: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
}

.error {
    color: red;
    margin-top: 10px;
}
.warning {
    background: #fff3cd;
    color: #856404;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
    font-size: 14px;
}
</style>